import { makeStyles } from "components/mui-core";
import { grayColor } from "vendor/material-dashboard-pro-react-v1/assets/jss/material-dashboard-pro-react";

const useStyles = makeStyles()((theme) => ({
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
    backgroundColor: grayColor[5],
    //marginLeft: DRAWER_WIDTH,
  },
}));

export default useStyles;
